export default function shippingAppStocksComponent() {
    return {
        initStocks(authID = null) {
            // console.log('Stocks Initialized ' + authID);
        },

        // filterOrders() {
        //     DatatableOrders();
        // },

        submitApprovalOnReceiveProductToStock(transactionStockId) {
            Swal.fire({
                title: "Are you sure ?",
                text: "You Will Approval To Receive This Product To Stock?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, change it !",
                cancelButtonText: "No, cancel !",
                closeOnConfirm: false,
                closeOnCancel: false
            }).then((confirmed) => {
                if (confirmed.value == true) {

                    axios.post(`/sa/api/transactions-stock/${transactionStockId}/approvalTransactionStock`)
                        .then(function (response) {
                            // showSwal('successful-opperation', response.data.message);


                            $('#btn-'+response.data.data.id).remove();
                            $('#td-'+response.data.data.id).html(`<span class="btn btn-success" style="cursor: default !important; font-size: 14px;">عملية مؤكدة</span>`);



                        }, error => {
                            showSwal('something-wrong', '');
                        });

                } else if(confirmed.dissmiss == "cancel") {
                    Swal.fire("Cancelled", "Status Unchanged !", "error");
                }
            });
        }

    }
}
